import request from '@/request'

export async function getCertificatesByUser (userId, params) {
  return await request({
    url: `/users/${userId}/certificates`,
    method: 'get',
    params
  })
}

export async function sendEmailCertificate(courseId) {
  const response = await request({
    url: `/certificate/${courseId}/send`,
    method: 'post'
  })

  return response.data
}
